import { Controller } from 'stimulus';
import Swiper, { Pagination, EffectFade, Navigation, Controller as SwiperController } from 'swiper';

class SliderRelated extends Controller {
    connect() {
      // Slider related carousel
      Swiper.use([Pagination, EffectFade, Navigation, SwiperController]);
      
      const items = document.querySelectorAll('.swiper-slider-related');

      /**
      * Adds a unique class to the element and returns the new class name 
      * 
      * @param {String} className 
      * @param {Int} uniqueId 
      * @returns String unique classname
      */
      const uniqueEls = (className, containerEl, uniqueId) => {
        if (containerEl.querySelector(`.${className}`)) containerEl.querySelector(`.${className}`).classList.add(`${className}__${uniqueId}`);
        return `.${className}__${uniqueId}`;
      }

      items.forEach((item, i) => {
        const slider = item;
        if (slider.dataset.initialized) return;
        else slider.dataset.initialized = true;

        slider.classList.add(`swiper-slider-related__${i}`);
        const sliderContainer = slider.parentNode.parentNode;
        const swiperFunction = (settings = {}) => {
          const genSettings = {
            grabCursor: true,
            loop: false,
            loopFillGroupWithBlank: true,
            watchOverflow: true,
            spaceBetween: 16,
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            slideVisibleClass: 'slider-related-visible',
            slidePrevClass: 'slider-related-prev',
            slideNextClass: 'slider-related-next',
          };
          settings = {
            autoplay: {
              delay: 5000,
            },
            breakpoints: {
              768: {
                slidesPerGroup: 2,
                spaceBetween: 32,
              },
              920: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 48,
                navigation: {
                  nextEl: uniqueEls('swiper-slider-related-button--next', sliderContainer, i),
                  prevEl: uniqueEls('swiper-slider-related-button--prev', sliderContainer, i),
                },
              },
              1280: {
                slidesPerView: 3,
                slidesPerGroup: 1,
                spaceBetween: 48,
                navigation: {
                  nextEl: uniqueEls('swiper-slider-related-button--next', sliderContainer, i),
                  prevEl: uniqueEls('swiper-slider-related-button--prev', sliderContainer, i),
                },
              },
            },
            pagination: {
              el: uniqueEls('swiper-slider-related-pagination', sliderContainer, i),
              bulletClass: 'swiper-pagination-bullet swiper-pagination-bullet-secondary',
              bulletActiveClass: 'swiper-pagination-bullet-active swiper-pagination-bullet-active-secondary',
              clickable: true,
            },
            on: {
              init: function (swiper) {
                if(swiper.slides.length <= 1) {
                  $(`.swiper-slider-related-button--next__${i}`).hide();
                  $(`.swiper-slider-related-button--prev__${i}`).hide();
                }
              },
              lock: function () {
                $(`.swiper-slider-related-button--next__${i}`).hide();
                $(`.swiper-slider-related-button--prev__${i}`).hide();
              },
            },
            ...genSettings
          };

          return settings;
        }

        const related_slider = new Swiper(`.swiper-slider-related__${i}`, swiperFunction()); 
        related_slider.controller.control = related_slider;
      });
    }
}


SliderRelated.targets = ['slider'];

export default SliderRelated;